// extracted by mini-css-extract-plugin
export default {"searchType":"search-type_searchType__GdGb1","active":"search-type_active__kmxpb"};